import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './simple-confirm-action-dialog.component.html'
})
export class SimpleConfirmActionDialogComponent implements OnInit {
  public message: string;
  public title: string;

  constructor(private matDialogRef: MatDialogRef<SimpleConfirmActionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.title = data.title;
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('500px');
  }

  closeDialog() {
    this.matDialogRef.close(false);
  }

  confirm() {
    this.matDialogRef.close(true);
  }
}
